export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

/**
 * TODO Sven/Morten: Should be either generated from auth0 endpoint "permissions" into a .d.ts file with a hook in codegen.ts or introduced as an enum from backend
 */
export const PERMISSIONS = {
  ESTAID: "estaid",
  FILE_CREATE_ORG: "file:create:org",
  FILE_DELETE_ORG: "file:delete:org",
  FILE_READ_ORG: "file:read:org",
  FILE_UPDATE_ORG: "file:update:org",
  LIST_CREATE_ORG: "list:create:org",
  LIST_DELETE_ORG: "list:delete:org",
  LIST_READ_ORG: "list:read:org",
  LIST_UPDATE_ORG: "list:update:org",
  LOKALE_BASEN_READ_ORG: "lokale_basen:read:org",
  NOTE_CREATE_ORG: "note:create:org",
  NOTE_DELETE_ORG: "note:delete:org",
  NOTE_READ_ORG: "note:read:org",
  NOTE_UPDATE_ORG: "note:update:org",
  ORGANIZATION_READ_ALL: "organization:read:all",
  ORGANIZATION_READ_OWN: "organization:read:own",
  PORTFOLIO_BUSINESS_PLANS_CREATE_ORG: "portfolio_business_plans:create:org",
  PORTFOLIO_BUSINESS_PLANS_DELETE_ORG: "portfolio_business_plans:delete:org",
  PORTFOLIO_BUSINESS_PLANS_READ_ORG: "portfolio_business_plans:read:org",
  PORTFOLIO_BUSINESS_PLANS_UPDATE_ORG: "portfolio_business_plans:update:org",
  PORTFOLIO_CREATE_ORG: "portfolio:create:org",
  PORTFOLIO_DELETE_ORG: "portfolio:delete:org",
  PORTFOLIO_READ_ORG: "portfolio:read:org",
  PORTFOLIO_SALES_READ_ORG: "portfolio_sales:read:org",
  PORTFOIO_SALES_CREATE_ORG: "portfolio_sales:create:org",
  PORTFOLIO_SALES_UPDATE_ORG: "portfolio_sales:update:org",
  PORTFOLIO_SALES_DELETE_ORG: "portfolio_sales:delete:org",
  PORTFOLIO_VALUATIONS_READ_ORG: "portfolio_valuations:read:org",
  PORTFOLIO_VALUATIONS_CREATE_ORG: "portfolio_valuations:create:org",
  PORTFOLIO_VALUATIONS_UPDATE_ORG: "portfolio_valuations:update:org",
  PORTFOLIO_VALUATIONS_DELETE_ORG: "portfolio_valuations:delete:org",
  RENT_REQUEST_READ_ORG: "rent_request:read:org",
  RENT_REQUEST_WRITE_ORG: "rent_request:write:org",
  SUPERSET_ADMIN: "superset:admin",
  TEMPLATE_BUILDER_READ_ORG: "template_builder:read:org",
  ACTION_PLANS_READ_ORG: "action_plans:read:org",
  ACTION_PLANS_CREATE_ORG: "action_plans:create:org",
  ACTION_PLANS_UPDATE_ORG: "action_plans:update:org",
  ACTION_PLANS_DELETE_ORG: "action_plans:delete:org",
  INTEGRATION_CREATE: "integration:create",
  INTERGRATION_DELETE: "integration:delete",
  INTEGRATION_READ: "integration:read",
  INTEGRATION_SCHEDULE: "integration:schedule",
  INTEGRATION_UPDATE: "integration:update",
  FRONTPAGE_EDIT: "frontpage:update",
} as const;

export const useHasPermissions = (...testPermissions: Permission[]) => {
  const me = useMe();

  const result = computed(() => (me.loading.value ? false : testPermissions.every((permission) => me.result.value?.me.permissions.includes(permission))));

  return {
    loading: me.loading,
    result,
  };
};
